import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "status-info" }
const _hoisted_2 = { class: "status-info__body" }
const _hoisted_3 = {
  key: 0,
  class: "status-info__additional-info additional-info"
}
const _hoisted_4 = { class: "additional-info__name" }
const _hoisted_5 = { class: "additional-info__count" }
const _hoisted_6 = {
  key: 1,
  class: "status-info__errors errors"
}
const _hoisted_7 = { class: "errors__list" }
const _hoisted_8 = {
  key: 1,
  class: "status-info__not-found"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.getMainInfo.length || _ctx.info.errors.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.getMainInfo.length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getMainInfo, (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item,
                      class: "additional-info__item"
                    }, [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(item.label) + ": ", 1),
                      _createElementVNode("span", _hoisted_5, _toDisplayString(item.value), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.info.errors.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _cache[0] || (_cache[0] = _createElementVNode("h4", { class: "errors__subtitle" }, "Ошибки, возникшие при загрузке:", -1)),
                  _createElementVNode("ul", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.errors, (error) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: error,
                        class: "errors__item"
                      }, _toDisplayString(error), 1))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock("p", _hoisted_8, "Нет данных"))
    ])
  ]))
}